module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/213-gibraltar-0d8ca64e3cda074a0dcee6323854f0e7.svg";